import { Form } from 'formik';
import { FormItem, Input } from 'formik-antd';
import styled from 'styled-components';
import { Checkbox as AntCheckbox } from 'antd';

export const InputStyled = styled(Input)`
  border-radius: 10px;
  align-items: center;
  border: solid 0.5px #ececec;
  background-color: #fff;
  padding: 1em;`;

export const StyledForm = styled(Form)`
  margin-top: 2vh;
  @media (max-width: 768px) {
    padding: 1em 1em;
  }`;

export const FormItemStyled = styled(FormItem)`

  input:focus{
    border-color: #198754;
    box-shadow: 0 0 0 0.5px #198754;
    border-right-width: 1px;
    outline: 0;
  }

  input:hover {
    border-color: #198754;
    border-right-width: 1px;
  }

  .ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover {
    border-color: #198754;
    border-right-width: 0.5px;
    z-index: 1;
  }

  .ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):focus {
    box-shadow: 0 0 0 0.5px #198754;
    border-right-width: 1px;
    outline: 0;
    z-index: 1;
  }
`;

export const Checkbox = styled(AntCheckbox)`
  ${({ checked }): string => checked === true
    ? `& > span {
        color: #039855;
        font-weight: 600;
    }`
    : ''}
  & .ant-checkbox-checked {
    & .ant-checkbox-inner {
      background-color: #039855
    ;
    }
  }
  & .ant-checkbox-inner {
    width: 18px;
    height: 18px;
    border-radius: 4px;
  }
`;
